import React, { Fragment, useEffect, useState } from "react";
import { Label, Wrapper } from "./Panel";
import { ReactComponent as CloseIcon } from "../../.././../../assets/svg/solobuilder/close-icon.svg";
import { ReactComponent as DropdownIcon } from "../../../../../assets/svg/solobuilder/dropdown.svg";
import { useDispatch, useSelector } from "react-redux";
import BgArrow from '../../../../../assets/svg/bg-arrow.svg';
import {Listbox, Transition} from "@headlessui/react";
import {updateGridStyles} from "../../../../../stateManager/store/formCreation_v2/actions";
import {getComponents, getValue} from "../helpers";
import {onChange} from "./layout-components/helpers/on-change";

interface IApplyBackgroundImage {
  label: string;
  open: () => void;
  from?: string;
  menuVisibility?: boolean;
}

const CANVAS_BACKGROUND_IMAGE = "properties.styles.$deviceType.canvasBackgroundImage";
const GRC_BACKGROUND_IMAGE = "properties.styles.$deviceType.backgroundImage";

export const ApplyBackgroundImage: React.FC<IApplyBackgroundImage> = (props) => {
  const { label, open, from, menuVisibility } = props;
  const { gridStyles, deviceType, selectedElementId } = useSelector((state: any) => state.formJson); 
  const [url, setUrl] = useState<string>('');
  const { components } = getComponents()  
  const component = components[selectedElementId];

  const path = from === "canvas" ? CANVAS_BACKGROUND_IMAGE : GRC_BACKGROUND_IMAGE
  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, path.split("."), deviceType);
      setUrl(previousValue?.url)
    } else {
      const previousValue = gridStyles[ deviceType ]?.canvasBackgroundImage || {};
      setUrl(previousValue?.url)
    }
  }, [gridStyles[deviceType]?.canvasBackgroundImage, getValue(component, path.split("."), deviceType), deviceType])

  return (
    <div>
      <Wrapper >
        <Label id="Background-image" label={label} />
        <div
          onClick={(e)=>{e.stopPropagation();open();}}
          className="flex items-center justify-between"
          style={{
            height:"28px",
            width: "170px",
            border: menuVisibility?"1px solid #e27841":"1px solid #7D84924B",
            borderRadius:"2px",
            background:"rgba(239, 240, 244, 1)",
            color:"rgba(40, 43, 49, 1)",
            fontSize:"12px",
            padding:"7px",
            fontWeight:600,
            cursor:"pointer"
          }}
        >
          <span className="truncate" style={{width:"145px", color: (url && url != '') ? "rgba(41, 45, 50, 0.4)" : "rgba(40, 43, 49, 1)"}} >
            {(url && url != '') ? url : "Add image url"}
          </span>
          <img src={BgArrow} alt="bg-arrow" className="cursor-pointer" />
        </div>
      </Wrapper>
    </div>
  );
};
interface IBackgroundImageMenu {
  from?: string;
  where: string;
  close: () => void;
  isCheckedIn: boolean;
  backgroundMenuContext?: any;
  type:string;
}

const backgroundSizeOptions = [
  {
    label: "Auto",
    value: "auto"
  },
  {
    label: "Contain",
    value: 'contain'
  },
  {
    label: "Cover",
    value: "cover"
  }
]
const backgroundRepeatOptions = [
  {
    label: 'Repeat',
    value: "repeat"
  },
  {
    label: "No repeat",
    value: "no-repeat"
  }
]

export const BackgroundImageMenu: React.FC<IBackgroundImageMenu> = (
  props: IBackgroundImageMenu
) => {
  const dispatch = useDispatch();
  const {from, where, close, isCheckedIn, type} = props;
  const {gridStyles, deviceType, selectedElementId} = useSelector((state: any) => state.formJson);
  const { components } = getComponents()  
  const component = components[selectedElementId];
  const [oldValues, setOldValues] = useState<any>(null);
  const [values,setValues]=useState<any>(null);
  const [ddSelected, setDdSelected] = useState({
    size: {
      label: "Cover",
      value: "cover" 
    },
    repeat: {
      label: "No repeat",
      value: "no-repeat"
    }
  });

  const path = type === "canvas" ? CANVAS_BACKGROUND_IMAGE : GRC_BACKGROUND_IMAGE

  useEffect(() => {
    if (component) {
      const previousValue = getValue(component, path.split("."), deviceType);
      setOldValues(previousValue)
      setValues(previousValue)
      setDdSelected({
        ...ddSelected,
        size: backgroundSizeOptions.filter((item) => item.value === previousValue?.size)[ 0 ],
        repeat: backgroundRepeatOptions.filter((item) => item.value === previousValue?.repeat)[ 0 ],
      })
    } else {
      const previousValue = gridStyles[deviceType]?.canvasBackgroundImage || {};
      setValues(previousValue)
      setDdSelected({
        ...ddSelected,
        size: backgroundSizeOptions.filter((item) => item.value === previousValue?.size)[ 0 ],
        repeat: backgroundRepeatOptions.filter((item) => item.value === previousValue?.repeat)[ 0 ],
      })
    }
  }, [getValue(component, path.split("."), deviceType), deviceType])


  const handleOnChange = (value:any) => {
    if (from === "GridLayout") {
      handleChange(where, value)
    } else {
      onChange({
        path,
        value,
        oldValue: oldValues,
        setOldValue: setOldValues,
        selectedElementId
      })
    }
  }

  const handleChange = (path: any, value: any) => {
    dispatch(
      updateGridStyles({
        path: path,
        value,
      })
    );
  }

  const ddBgSizeOnchange = (option:any) => {
    setDdSelected({...ddSelected, size: option})
    setValues((prev:any) => ({...prev, size: option.value}))
    const updatedValue = {...values, size: option.value}
    handleOnChange(updatedValue)
  }

  const ddBgRepeatOnChange = (option:any) => {
    setDdSelected({...ddSelected, repeat: option})
    setValues((prev:any) => ({...prev, repeat: option.value}))
    const updatedValue = {...values, repeat: option.value}
    handleOnChange(updatedValue)
  }

  useEffect (() => {
    document.addEventListener('keydown', detectKeyDown)
    return () => {
        document.removeEventListener('keydown', detectKeyDown);
    }
}, [])

const detectKeyDown = (e:KeyboardEvent) => {
    if (e.key === "Escape") {
        close();
    }
}

  return (
    <div className="custom-color background-image-panel" style={{height: "155px", bottom: 10}} onClick={(e) => e.stopPropagation()}>
      <div
        className="w-full h-10 flex justify-between items-center text-xs font-semibold "
        style={{
          background: "#EFF0F4",
          padding: "0px 10px"
        }}
      >
        <div style={{fontSize: "12px", fontWeight: 600}}>{type==="SnackBar"?"Icon settings":"Background settings"}</div>
        <CloseIcon
          className="cursor-pointer"
          onClick={() => close()}
        ></CloseIcon>
      </div>
      <div className="box-body" >
        <div className="panel-div" >
          <span className="label" >Url</span>
          <input disabled={!isCheckedIn}
            onChange={(e: any) => {
              const change = e.target.value;
              setValues({...values, url: change})
              const updatedValue = {...values, url: change};
              handleOnChange(updatedValue)
            }}
            value={values?.url || ""}
            className="panel-input" style={{width: "130px"}} placeholder="Paste image url" />
        </div>
        <div className="panel-div" >
          <span className="label" >Size</span>
          <GridDropdown disabled={!isCheckedIn} onChange={ddBgSizeOnchange} selected={ddSelected.size} defaultValue={"Cover"} options={backgroundSizeOptions} />
        </div>
        <div className="panel-div" >
          <span className="label" >Repeat</span>
          <GridDropdown disabled={!isCheckedIn} onChange={ddBgRepeatOnChange} selected={ddSelected.repeat} defaultValue={"No repeat"} options={backgroundRepeatOptions} />
        </div>
      </div>
    </div>
  );
};


interface IDropdown {
  options: any;
  selected: any;
  onChange: any;
  disabled?: boolean;
  defaultValue?: any;
}

export const GridDropdown: React.FC<IDropdown> = ({
  options,
  selected,
  defaultValue,
  onChange,
  disabled
}) => {
  return (
    <div
      style={{ width:"131px" }}
      className="relative col-span-1 bg-white text-gray-900 text-lg rounded-lg"
    >
      <Listbox disabled={disabled} value={selected} onChange={onChange}>
        {({ open }) => {
          return (
            <>
              <Listbox.Button style={{
                borderRadius: "2px", border: open ? "1px solid #e27841" : "1px solid #7D84924B",
                display: "flex", alignItems: "center", height: "28px", width: "100%", cursor: "pointer", padding: "10px 4px 10px 4px"
              }}
                className="relative text-lx rounded-lg bg-white text-left focus:outline-none">
                <span style={{ color: "#292D32", lineHeight: "15px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", fontSize: "12px", fontWeight: 500 }}>
                  {selected?.label || defaultValue}
                </span>
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <DropdownIcon className="h-3 w-3 text-gray-400" />
                </span>
              </Listbox.Button>
              <Transition
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
               <Listbox.Options style={{ width: "131px", left: "-1px", top:"-64px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "0px 5px 8px rgba(125, 132, 146, 0.11)", borderRadius: "4px", maxHeight: "175px", paddingBottom: "10px" }} className="absolute w-full overflow-auto rounded bg-white focus:outline-none z-40 cursor-pointer">
                  {options.map((opt:any, index:any) => (
                    <Listbox.Option
                      key={index}
                      style={{ fontSize: "11px", fontWeight: 600, margin: "10px 10px 0px 10px" }}
                      className="relative cursor-pointer select-none"
                      value={opt}
                    >
                      {({ active }) => {
                        return (
                          <span
                            style={{ fontSize: selected ? "12px" : "11px", lineHeight: "normal" }}
                            className={`block truncate ${active ? "hover:text-selectedText_color" : ""} font-medium ${(selected?.label||defaultValue) === opt?.label ? 'text-selectedText_color' : "text-unselectedText_color"}`}
                          >
                            {opt.label}
                          </span>
                        )
                      }}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </>
          )
        }}
      </Listbox>
    </div >
  );
};
